import { create } from 'zustand';
import { LocalStorageUtils } from '@shared/utils';
import { AuthUser } from '@shared/types';

interface UseAuthUserStore {
  data: AuthUser | undefined;
  setAuthUser: (authUser: AuthUser) => void;
  clear: () => void;
}

export const useAuthUserStore = create<UseAuthUserStore>((set) => ({
  data: LocalStorageUtils.getIppUser(),

  setAuthUser: (authUser) => set({ data: authUser }),
  clear: () => set({ data: undefined }),
}));
